import { createReducer } from "reduxsauce";
import ReducerRegister from "../../ReducerRegister";
import AsyncActionReducers from "../../AsyncActionReducers";
import { ActionTypes } from "../../actionTypes/screens/homework/NewListActionTypes";
import NewListService from "../../../services/screens/homework/NewListService";
import { ActionTypes as UnitActionTypes } from "../../actionTypes/screens/homework/HomeworkUnitActionTypes";
// import { ActionTypes as NotificationActionTypes } from "../../actionTypes/NotificationActionTypes";
import UIDs from "../../../UIDs";
import _ from "lodash";
// import OfflineHomeworkListService from "../../../services/screens/offline/OfflineHomeworkListService";
// import { Actions as OfflineStorageActions, ActionTypes as OfflineStorageActionTypes } from "../../actionTypes/utils/OfflineStorageActionTypes";
import { ActionTypes as CompleteHomeworkActionTypes } from "../../actionTypes/screens/homework/CompleteHomeworkActionTypes";
import * as HomeworkHelper from "../../../utils/HomeworkHelper";
import DebugLogger from "../../../../utils/DebugLogger";

//
// Actions
//
function filterDuplicatedHomework(list) {
    var keys = new Map();
    var result = [];
    list.forEach((it, index) => {
        if (!keys.has(it.userHomeworkId)) {
            keys.set(it.userHomeworkId, index);
            result.push(it);
        }
    });
    return result;
}

const checkHomeworksForDownload = (data, successCallback, failureCallback) => {
    let homeowrkList = [];
    if (data.newHomeworks) {
        // loadScreenView
        homeowrkList = _.cloneDeep(data.newHomeworks.userHomeworks);
    }
    if (data.userHomeworks) {
        // loadMore
        homeowrkList = _.cloneDeep(data.userHomeworks);
    }
    let homeworkDone = new Set();
    let homeworkUndone = [];
    let homeworkIdList = homeowrkList.map(item => item.homeworkId);
    const loadOneByOne = homeworkId => {
        return new Promise((resolve, reject) => {
            if (homeworkId) {
                HomeworkHelper.loadData(
                    homeworkId,
                    () => {
                        homeworkDone.add(homeworkId);
                        resolve(loadOneByOne(homeworkIdList.shift()));
                    },
                    error => {
                        //reject(error);
                        DebugLogger.log(error);
                        homeworkUndone.push(homeworkId);
                        resolve(loadOneByOne(homeworkIdList.shift()));
                    }
                );
            } else {
                resolve(null);
            }
        });
    };
    loadOneByOne(homeworkIdList.shift())
        .then(() => {
            data.homeworkDone = homeworkDone;
            data.homeworkUndone = homeworkUndone;
            if (successCallback) {
                successCallback(data);
            }
        })
        .catch(error => {
            if (failureCallback) {
                failureCallback(error);
            }
        });
};

const loadScreenView = (successCallback, failureCallback) => {
    NewListService.loadScreenView(
        response => {
            checkHomeworksForDownload(response, successCallback, failureCallback);
        },
        error => {
            if (failureCallback) {
                failureCallback(error);
            }
        }
    );
};

const Actions = {
    loadScreenViewAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            loadScreenView(
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                    // dispatch(OfflineStorageActions.addHomeworkDownloadTaskAndStart(response.homeworkUndone));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error,
    }),

    updateScreenInBackgroundAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_ASYNC });

            loadScreenView(
                response => {
                    dispatch(Actions.updateScreenInBackgroundSuccess(response));
                    // dispatch(OfflineStorageActions.addHomeworkDownloadTaskAndStart(response.homeworkUndone));
                },
                error => {
                    dispatch(Actions.updateScreenInBackgroundFailure(error));
                }
            );
        };
    },

    updateScreenInBackgroundSuccess: data => ({
        type: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_SUCCESS,
        parentType: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
    }),

    updateScreenInBackgroundFailure: error => ({
        type: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_FAILURE,
        parentType: ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_ASYNC,
        postReducer: updateScreenInBackgroundFailurePostReducer,
        error,
    }),

    refreshScreenAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.REFRESH_SCREEN_ASYNC });

            loadScreenView(
                response => {
                    dispatch(Actions.refreshScreenSuccess(response));
                    // dispatch(OfflineStorageActions.addHomeworkDownloadTaskAndStart(response.homeworkUndone));
                },
                error => {
                    dispatch(Actions.refreshScreenFailure(error));
                }
            );
        };
    },

    refreshScreenSuccess: data => ({
        type: ActionTypes.REFRESH_SCREEN_SUCCESS,
        parentType: ActionTypes.REFRESH_SCREEN_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
    }),

    refreshScreenFailure: error => ({
        type: ActionTypes.REFRESH_SCREEN_FAILURE,
        parentType: ActionTypes.REFRESH_SCREEN_ASYNC,
        postReducer: updateScreenInBackgroundFailurePostReducer,
        error,
    }),

    loadMoreAsync: vo => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.REFRESH_SCREEN_ASYNC });

            NewListService.loadMore(
                vo,
                response => {
                    let homeowrkList = [];
                    if (response.newHomeworks) {
                        // loadScreenView
                        homeowrkList = response.newHomeworks.userHomeworks;
                    }
                    if (response.userHomeworks) {
                        // loadMore
                        homeowrkList = response.userHomeworks;
                    }
                    response.homeworkDone = new Set(homeowrkList.map(item => item.homeworkId));
                    response.homeworkUndone = [];
                    dispatch(Actions.loadMoreSuccess(response, vo.type));
                },
                error => {
                    dispatch(Actions.loadMoreFailure(error));
                }
            );
        };
    },

    loadMoreSuccess: (data, tabIndex) => ({
        type: ActionTypes.REFRESH_SCREEN_SUCCESS,
        parentType: ActionTypes.REFRESH_SCREEN_ASYNC,
        postReducer: loadMoreSuccessPostReducer,
        data,
        tabIndex,
    }),

    loadMoreFailure: error => ({
        type: ActionTypes.REFRESH_SCREEN_FAILURE,
        parentType: ActionTypes.REFRESH_SCREEN_ASYNC,
        postReducer: updateScreenInBackgroundFailurePostReducer,
        error,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    newList: null,
    historyList: null,
    homeworkDone: new Set(),
    receivedHomeworkId: "",
    receivedUserHomeworkId: "",
    newListParams: {
        pageSize: 10,
        pageIndex: 1,
        hasMore: false,
    },
    historyListParams: {
        pageSize: 15,
        pageIndex: 1,
        hasMore: false,
    },
    undoneHomeworkList: new Set(),
    isDownloading: false,
    needUpdateInBackground: false,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    const { newHomeworks, historyHomeworks, homeworkDone } = data;
    const newList = filterDuplicatedHomework(newHomeworks.userHomeworks);
    const newListParams = { ...INITIAL_STATE.newListParams, hasMore: newHomeworks.totalCount > newList.length };
    const historyList = filterDuplicatedHomework(historyHomeworks.userHomeworks);
    const historyListParams = { ...INITIAL_STATE.historyListParams, hasMore: historyHomeworks.totalCount > historyList.length };
    return { ...state, newList, historyList, homeworkDone, newListParams, historyListParams, needUpdateInBackground: false };
};

const loadMoreSuccessPostReducer = (state, { data, tabIndex }) => {
    const { userHomeworks, totalCount, homeworkDone } = data;
    let oriHomeworkDone = new Set(state.homeworkDone);
    let newHomeworkDone = new Set([...oriHomeworkDone, ...homeworkDone]);
    if (tabIndex === 0) {
        let newList = Array.from(state.newList);
        newList = filterDuplicatedHomework(newList.concat(userHomeworks));
        let newListParams = _.clone(state.newListParams);
        newListParams.pageIndex += 1;
        newListParams.hasMore = totalCount > newList.length;
        return { ...state, newList, newListParams, homeworkDone: newHomeworkDone, needUpdateInBackground: false };
    }
    if (tabIndex === 1) {
        let historyList = Array.from(state.historyList);
        historyList = filterDuplicatedHomework(historyList.concat(userHomeworks));
        let historyListParams = _.clone(state.historyListParams);
        historyListParams.pageIndex += 1;
        historyListParams.hasMore = totalCount > historyList.length;
        return { ...state, historyList, historyListParams, homeworkDone: newHomeworkDone, needUpdateInBackground: false };
    }
    return { ...state };
};

const loadHomeworkDataSuccessReducer = (state, { homeworkId }) => {
    let newHomeworkDone = _.cloneDeep(state.homeworkDone);
    newHomeworkDone.add(homeworkId);
    return { ...state, homeworkDone: newHomeworkDone };
};

const completeHomeworkReducer = (state, { data }) => {
    let newList = Array.from(state.newList);
    let historyList = Array.from(state.historyList);
    let idx = newList.findIndex(h => h.userHomeworkId === data.userHomeworkId);
    let homework = newList[idx];
    const { completedUnitCount, correctUnitCount, totalUnitCount, subjectiveUnitCount, status, avgScore, endOn } = data;
    homework = { ...homework, completedUnitCount, correctUnitCount, totalUnitCount, subjectiveUnitCount, status, avgScore, endOn };
    if (status > 1) {
        newList.splice(idx, 1);
        if (status === 4) {
            historyList.unshift(homework);
        }
    } else {
        newList.splice(idx, 1, homework);
    }
    return { ...state, newList, historyList };
};

const receivedNewAssignmentReducer = (state, { data }) => {
    let newList = Array.from(state.newList);
    let receivedHomeworkId = "";
    let receivedUserHomeworkId = "";
    if (newList.every(u => u.userHomeworkId !== data.userHomeworkId && u.homeworkAssignmentId !== data.homeworkAssignmentId)) {
        newList.unshift(data);
        receivedHomeworkId = data.homeworkId;
        receivedUserHomeworkId = data.userHomeworkId;
    }

    return { ...state, newList, receivedHomeworkId, receivedUserHomeworkId };
};

const receivedAssignmentRecallReducer = (state, { data }) => {
    let newList = Array.from(state.newList);
    let idx = newList.findIndex(u => u.userHomeworkId === data.userHomeworkId);
    if (idx > -1) {
        newList.splice(idx, 1);
    }
    let historyList = Array.from(state.historyList);
    idx = historyList.findIndex(u => u.userHomeworkId === data.userHomeworkId);
    if (idx > -1) {
        historyList.splice(idx, 1);
    }
    return { ...state, newList, historyList };
};

const receivedRemoveFromClassReducer = (state, { data }) => {
    let classUserHomeworks = Array.from(data);
    let newList = Array.from(state.newList);
    let historyList = Array.from(state.historyList);
    classUserHomeworks.forEach(userHomeworkId => {
        let idx = newList.findIndex(u => u.userHomeworkId === userHomeworkId);
        if (idx > -1) {
            newList.splice(idx, 1);
        }
        idx = historyList.findIndex(u => u.userHomeworkId === userHomeworkId);
        if (idx > -1) {
            historyList.splice(idx, 1);
        }
    });
    return { ...state, newList, historyList };
};

const appBecomeActiveReducer = state => {
    return { ...state, needUpdateInBackground: true };
};

const startHomeworkSuccessReducer = (state, { data }) => {
    const { userHomeworkId } = data;
    let newList = Array.from(state.newList);
    let historyList = Array.from(state.historyList);
    let idx = newList.findIndex(h => h.userHomeworkId === userHomeworkId);
    let homework = newList[idx];
    if (idx > -1 && homework && homework.status === 0) {
        homework = { ...homework };
        homework.status = 1;
        newList[idx] = homework;
    }

    return { ...state, newList, historyList };
};

const updateUnitResultReducer = (state, { data }) => {
    let newList = Array.from(state.newList);
    //let homework = newList.find(u => u.userHomeworkId === data.userHomeworkId);
    let index = _.findIndex(newList, u => u.userHomeworkId === data.userHomeworkId);
    if (index > -1) {
        let orgHomework = newList[index];
        if (orgHomework && orgHomework.status === 0) {
            let newHomework = { ...orgHomework };
            newHomework.status = 1;
            newList[index] = newHomework;
        }
    }

    return { ...state, newList };
};

const userHomeworkStatusChangeReducer = (state, { data }) => {
    let newList = Array.from(state.newList);
    let index = _.findIndex(newList, u => u.userHomeworkId === data.userHomeworkId);
    if (index > -1) {
        let orgHomework = newList[index];
        if (orgHomework) {
            let newHomework = { ...orgHomework };
            newHomework.localStatus = data.localStatus;
            newList[index] = newHomework;
        }
    }

    return { ...state, newList };
};

const updateScreenInBackgroundFailurePostReducer = (state, { error }) => {
    return { ...state, needUpdateInBackground: false };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [UnitActionTypes.COMPLETE_HOMEWORK_SUCCESS]: completeHomeworkReducer,
    [UnitActionTypes.UPDATE_UNIT_RESULT_SUCCESS]: updateUnitResultReducer,
    [UnitActionTypes.USER_HOMEWORK_STATUS_CHANGE]: userHomeworkStatusChangeReducer,
    [UnitActionTypes.START_HOMEWORK_SUCCESS]: startHomeworkSuccessReducer,
    // [OfflineStorageActionTypes.LOAD_HOMEWORK_DATA_SUCCESS]: loadHomeworkDataSuccessReducer,
    // [NotificationActionTypes.RECEIVED_NEW_ASSIGNMENT]: receivedNewAssignmentReducer,
    // [NotificationActionTypes.RECEIVED_ASSIGNMENT_RECALL]: receivedAssignmentRecallReducer,
    // [NotificationActionTypes.RECEIVED_REMOVE_FROM_CLASS]: receivedRemoveFromClassReducer,
    // [NotificationActionTypes.APP_BECOME_ACTIVE]: appBecomeActiveReducer,
    [ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPDATE_SCREEN_IN_BACKGROUND_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REFRESH_SCREEN_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.REFRESH_SCREEN_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.REFRESH_SCREEN_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_MORE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_MORE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_MORE_FAILURE]: AsyncActionReducers.failureReducer,
    [CompleteHomeworkActionTypes.COMPLETE_HOMEWORK_SUCCESS]: completeHomeworkReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.homework.newlist, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
